import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.css";
import "./assets/scss/responsive.css";
import reportWebVitals from "./reportWebVitals";
import App from "./routes";
import {ChatbotContextProvider} from "./context/chatbot-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <ChatbotContextProvider>
            <App/>
        </ChatbotContextProvider>
    </React.StrictMode>
);

reportWebVitals();
